"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconImage', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5.5 7C4.67157 7 4 6.32843 4 5.5C4 4.67157 4.67157 4 5.5 4C6.32843 4 7 4.67157 7 5.5C7 6.32843 6.32843 7 5.5 7Z', 'M2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1H2ZM3 10.0858V3H13V9.08579L11.2071 7.29289C10.8166 6.90237 10.1834 6.90237 9.79289 7.29289L7 10.0858L5.70711 8.79289C5.31658 8.40237 4.68342 8.40237 4.29289 8.79289L3 10.0858ZM3 12.9142V13H13V11.9142L10.5 9.41421L7.70711 12.2071C7.31658 12.5976 6.68342 12.5976 6.29289 12.2071L5 10.9142L3 12.9142Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M6 8C4.89543 8 4 7.10457 4 6C4 4.89543 4.89543 4 6 4C7.10457 4 8 4.89543 8 6C8 7.10457 7.10457 8 6 8Z', 'M1 2C1 1.44772 1.44772 1 2 1H18C18.5523 1 19 1.44772 19 2V18C19 18.5523 18.5523 19 18 19H2C1.44772 19 1 18.5523 1 18V2ZM3 3V12.5858L5.29291 10.2929C5.68343 9.90237 6.3166 9.90237 6.70712 10.2929L8.59495 12.1807L12.5614 7.36429C12.7514 7.13363 13.0345 7 13.3333 7C13.6322 7 13.9153 7.13363 14.1053 7.36429L17 10.8793V3H3ZM3 17V15.4142L6.00001 12.4142L7.95957 14.3738C8.15896 14.5732 8.43325 14.6791 8.7149 14.6655C8.99654 14.6519 9.25936 14.52 9.43861 14.3024L13.3333 9.57305L17 14.0254V17H3Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M7.5 10C6.11929 10 5 8.88071 5 7.5C5 6.11929 6.11929 5 7.5 5C8.88071 5 10 6.11929 10 7.5C10 8.88071 8.88071 10 7.5 10Z', 'M1 2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44772 23 2V22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22V2ZM3 3V16.5369L6.28302 13.1601C6.4713 12.9664 6.72991 12.8571 7.00001 12.8571C7.27011 12.8571 7.52873 12.9664 7.71701 13.1601L10.2607 15.7764L15.3861 9.37499C15.5758 9.13796 15.863 9 16.1667 9C16.4703 9 16.7575 9.13796 16.9473 9.37499L21 14.4367V3H3ZM3 21V19.406L7.00001 15.2917L9.61635 17.9828C9.8163 18.1884 10.0949 18.2983 10.3814 18.2846C10.6679 18.2708 10.9347 18.1346 11.114 17.9107L16.1667 11.6L21 17.6367V21H3Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5Z', 'M2.5 1C1.67157 1 1 1.67157 1 2.5V29.5C1 30.3284 1.67157 31 2.5 31H29.5C30.3284 31 31 30.3284 31 29.5V2.5C31 1.67157 30.3284 1 29.5 1H2.5ZM4 21.7205V4H28V18.8116L22.6773 12.0705C22.3922 11.7095 21.9573 11.4992 21.4973 11.5C21.0373 11.5009 20.6032 11.7127 20.3194 12.0747L13.6938 20.5282L10.4934 17.0948C10.2094 16.7901 9.81152 16.6172 9.39502 16.6176C8.97852 16.6179 8.5809 16.7913 8.29737 17.0964L4 21.7205ZM4 26.1182V28H28V23.6526L21.5044 15.4261L14.973 23.7593C14.7025 24.1044 14.2946 24.3139 13.8566 24.3326C13.4185 24.3513 12.9942 24.1775 12.6952 23.8567L9.39778 20.3192L4.09878 26.0211C4.06703 26.0553 4.03406 26.0877 4 26.1182Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;